import React from 'react';
import '../css/components/Disclaimer.css';
import info from '../assets/img/icon_info.svg'
import warning from '../assets/img/icon_warning.svg'

export default function Disclaimer(props) {
  const {mensaje,error,centrado} = props;
  let dc = 'disclaimer-container';
  return ( 
    <div className={!centrado ?  dc :  dc +' centrado'}>
    {mensaje && (
      <div className=''>
        {error
          ? <img alt="warn" src={warning} width='16px'/>
          : <img alt="info" src={info} width='16px'/>
        }
      </div>
    )}
    <div className='disclaimer-message'>{mensaje}</div>
  </div>
  );
}
